import React, { useState, useEffect } from 'react';
import CommonModalForm from '../../components/commonComponent/CommonModalForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import axios from '../../utils/axiosInstance';
import { FaEdit, FaTrash } from 'react-icons/fa'; 

const FeedbackType = () => {
  const [feedbackType, setFeedbackType] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({ name: '' });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10); 
  // const limit = 10;

  useEffect(() => {
    fetchFeedbackType(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const fetchFeedbackType = async (page = 1, search = '') => {
    try {
      const res = await axios.get(`/admin/api/feedbacktype?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      const { feedbackTypes = [], totalCount = 0 } = res.data;
      setFeedbackType(feedbackTypes);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error('Failed to fetch FeedbackType:', err);
    }
  };

 const handleSave = async () => {
  const validationErrors = validateForm(formValues, {
    name: { required: true },
  });

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  try {
    if (editingId) {
      await axios.put(`/admin/api/feedbacktype/${editingId}`, formValues);
      toastSuccess('FeedbackType updated successfully!');
    } else {
      await axios.post('/admin/api/feedbacktype', formValues);
      toastSuccess('FeedbackType added successfully!');
    }

    setEditingId(null);
    setCurrentPage(1);
    fetchFeedbackType(1, searchQuery);
    handleCancel();
  } catch (err) {
    console.error('Failed to save FeedbackType:', err);
    toastError('Failed to save FeedbackType');
  }
};

const handleEdit = (feedbackType) => {
  console.log(feedbackType); // check if _id or id
  setFormValues({ name: feedbackType.name });
  setEditingId(feedbackType._id); // or role.id
  setShowModal(true);
};

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/admin/api/feedbacktype/${id}`);
      toastSuccess('FeedbackType deleted successfully!');
      setCurrentPage(1);  // reset to first page after delete
      fetchFeedbackType(1, searchQuery);
    } catch (err) {
      console.error('Failed to delete FeedbackType:', err);
      toastError('Failed to delete FeedbackType');
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormValues({ name: '' });
    setEditingId(null);
    setErrors({});
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0"> FeedbackType</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search FeedbackType..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1); // reset page on search
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">FeedbackType List</h5>
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowModal(true)}
          >
            + Add New FeedbackType
          </button>
        </div>
        <div className="table-responsive">
        <div className="card-body p-0">
          <table
            className="table table-bordered table-sm mb-0"
          >
            <thead className="table-light">
              <tr>
                <th className="py-1 px-2 w-5">Sr no.</th>
                <th className="py-1 px-2">FeedbackType Name</th>
                <th className="py-1 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {feedbackType.length > 0 ? (
                feedbackType.map((feedbackTypeItem, idx) => (
                  <tr key={feedbackTypeItem._id}>
                    <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                    <td className="py-1 px-2">{feedbackTypeItem.name}</td>
                    <td className="py-1 px-2">
                      <button
                        className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0 text-primary-custom"
                        title="Edit"
                        onClick={() => handleEdit(feedbackTypeItem)}
                      >
                       <FaEdit size={14} />
                      </button>
                      <button
                        className="btn btn-sm py-0 px-2 fs-6 lh-sm shadow-none border-0 text-danger"
                        onClick={() => handleDelete(feedbackTypeItem._id)}
                        title="Delete"
                      >
                        <FaTrash size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-2">No FeedbackType found.</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2 p-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className="{`btn btn-sm page-btn ${currentPage === page ? 'active' : ''}`}"
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>

      <CommonModalForm
        visible={showModal}
        title={editingId ? 'Edit FeedbackType' : 'Add FeedbackType'}
        fields={[
              { name: 'name', label: 'FeedbackType', placeholder: 'Enter FeedbackType Name' }
            ]}
        values={formValues}
        errors={errors}
        onChange={setFormValues}
        onSubmit={handleSave}
        onCancel={handleCancel}
        submitLabel={editingId ? 'Update' : 'Save'}
        requiredFields={['name']}
      />
    </div>
  );
};

export default FeedbackType;
